import hljs from 'highlight.js/lib/core';
import php from 'highlight.js/lib/languages/php';
import javascript from 'highlight.js/lib/languages/javascript';
import typescript from 'highlight.js/lib/languages/typescript';
import xml from 'highlight.js/lib/languages/xml';
import css from 'highlight.js/lib/languages/css';
import scss from 'highlight.js/lib/languages/scss';
import sql from 'highlight.js/lib/languages/sql';
import bash from 'highlight.js/lib/languages/bash';
import powershell from 'highlight.js/lib/languages/powershell';
import csharp from 'highlight.js/lib/languages/csharp';
import json from 'highlight.js/lib/languages/json';
import 'highlight.js/styles/atom-one-dark.css';

// registered under the exact keys used by config/templates/blocks/types/code-snippet.xml (codeLanguage values) -
// a new language there needs both a hljs import above and a registerLanguage line here
hljs.registerLanguage('php', php);
hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('typescript', typescript);
hljs.registerLanguage('xml', xml);
hljs.registerLanguage('html', xml);
hljs.registerLanguage('css', css);
hljs.registerLanguage('scss', scss);
hljs.registerLanguage('sql', sql);
hljs.registerLanguage('bash', bash);
hljs.registerLanguage('powershell', powershell);
hljs.registerLanguage('csharp', csharp);
hljs.registerLanguage('json', json);
// React/JSX and PowerShell's own "ps1" spelling aren't separate hljs grammars - reuse the closest one
hljs.registerAliases(['jsx', 'tsx'], {languageName: 'javascript'});
hljs.registerAliases(['ps', 'ps1'], {languageName: 'powershell'});
hljs.registerAliases(['cs'], {languageName: 'csharp'});
hljs.registerAliases(['sh', 'shell', 'zsh'], {languageName: 'bash'});

function initCodeCopy() {
    document.querySelectorAll('.article-code__copy').forEach((button) => {
        button.addEventListener('click', async () => {
            const code = button.closest('.article-code')?.querySelector('.article-code__pre code');
            if (!code) {
                return;
            }
            try {
                await navigator.clipboard.writeText(code.textContent);
            } catch (e) {
                return;
            }
            button.classList.add('is-copied');
            button.setAttribute('aria-label', button.dataset.copiedLabel || button.getAttribute('aria-label'));
            window.clearTimeout(button._copyResetTimeout);
            button._copyResetTimeout = window.setTimeout(() => {
                button.classList.remove('is-copied');
                button.setAttribute('aria-label', button.dataset.copyLabel || button.getAttribute('aria-label'));
            }, 2000);
        });
    });
}

export default function initHighlight() {
    document.querySelectorAll('.article-code__pre code').forEach((block) => hljs.highlightElement(block));
    initCodeCopy();
}
